import { render } from "./SterrenKikirpa.vue?vue&type=template&id=5563cb4b&scoped=true"
import script from "./SterrenKikirpa.vue?vue&type=script&lang=js"
export * from "./SterrenKikirpa.vue?vue&type=script&lang=js"

import "./SterrenKikirpa.vue?vue&type=style&index=0&id=5563cb4b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5563cb4b"]])

export default __exports__